module.exports = __webpack_public_path__ + "img/11.34b6556d.jpg";